/** Best display name from profile row and Supabase auth user metadata. */
export function resolveDisplayName(
  profile:
    | {
        display_name?: string | null;
        full_name?: string | null;
        institution_name?: string | null;
      }
    | null
    | undefined,
  user:
    | { email?: string | null; user_metadata?: Record<string, unknown> | null }
    | null
    | undefined,
  options?: { institution?: boolean }
): string {
  if (options?.institution) {
    const inst =
      profile?.institution_name?.trim() ||
      (typeof user?.user_metadata?.institution_name === 'string'
        ? user.user_metadata.institution_name.trim()
        : '');
    if (inst) return inst;
  }

  const fromDisplayName =
    profile && 'display_name' in profile ? profile.display_name?.trim() : undefined;
  if (fromDisplayName) return fromDisplayName;

  const fromProfile = profile?.full_name?.trim();
  if (fromProfile) return fromProfile;

  const meta = user?.user_metadata;
  const fromMeta =
    (typeof meta?.full_name === 'string' && meta.full_name.trim()) ||
    (typeof meta?.fullName === 'string' && meta.fullName.trim()) ||
    '';
  if (fromMeta) return fromMeta;

  const email = user?.email?.trim();
  if (email?.includes('@')) return email.split('@')[0] ?? 'Member';

  return 'Member';
}
